import { Expose } from "class-transformer";
import { IsNumber, IsOptional, IsString } from "class-validator";

export class Office {
  @Expose()
  @IsString()
  id!: string;
  @Expose()
  @IsNumber()
  officeProfileId!: number;
  @Expose()
  @IsString()
  shortName!: string;
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsNumber()
  contractorId!: number;
  @Expose()
  @IsOptional()
  @IsString()
  parentOfficeId!: string;
}
